/**
 * iter-386u-bi — Searchable Unit combobox.
 * Type-ahead search over STANDARD_UNITS plus free-form entry via Enter.
 */
import { useEffect, useRef, useState } from 'react';

export const STANDARD_UNITS = ['Sq.ft', 'R.ft', 'Nos', 'Unit', 'L.S', 'Rmt', 'Kg', 'Mtr', 'CFT', 'CUM'];

export default function UnitSelect({ value, onChange, className = '', testId, disabled = false }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState(value || '');
  const ref = useRef(null);
  useEffect(() => { setQuery(value || ''); }, [value]);
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);
  const q = query.trim().toLowerCase();
  const filtered = STANDARD_UNITS.filter((u) => u.toLowerCase().includes(q));
  const pick = (u) => { onChange(u); setQuery(u); setOpen(false); };
  const commonCls = `border border-stone-300 rounded bg-white px-2 py-1 text-xs w-full ${className}`;
  return (
    <div ref={ref} className="relative">
      <input
        value={query}
        onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (filtered[0]) pick(filtered[0]);
            else pick(query.trim());
          }
          if (e.key === 'Escape') setOpen(false);
        }}
        onBlur={() => { if (query !== value) onChange(query); }}
        placeholder="Sq.ft / Nos / Rmt…"
        disabled={disabled}
        className={commonCls}
        data-testid={testId}
      />
      {open && (
        <div className="absolute z-30 mt-1 w-full bg-white border border-stone-200 rounded shadow-lg max-h-48 overflow-y-auto" data-testid={testId ? `${testId}-menu` : undefined}>
          {filtered.length === 0 && (
            <div className="p-2 text-[11px] text-stone-400 italic">
              No standard unit matches. Press Enter to use "<strong>{query}</strong>" as-is.
            </div>
          )}
          {filtered.map((u) => (
            <button key={u} type="button" onMouseDown={(e) => { e.preventDefault(); pick(u); }}
              className={`w-full text-left px-2 py-1.5 hover:bg-emerald-50 text-xs ${u === value ? 'bg-emerald-50 text-emerald-900 font-medium' : ''}`}
              data-testid={testId ? `${testId}-opt-${u}` : undefined}
            >{u}</button>
          ))}
        </div>
      )}
    </div>
  );
}
